module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/about_us-acb0905cd45722148d0e9d8fdda541a9.jpg";